import _objectSpread from "D:/wenge-Obj/zhichuan/llm-agent-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import Vue from 'vue';
import locale from 'element-ui/lib/locale';
import VueI18n from 'vue-i18n';
//页面中自定义变量
//element-ui自带多语言配置
import zhLocale from 'element-ui/lib/locale/lang/zh-CN';
import zhTWLocale from 'element-ui/lib/locale/lang/zh-TW';
import enLocale from 'element-ui/lib/locale/lang/en';
Vue.use(VueI18n);
var messages = {
  en: _objectSpread(_objectSpread({}, require('./en.json')), enLocale),
  zh: _objectSpread(_objectSpread({}, require('./zh-CN.json')), zhLocale),
  hk: _objectSpread(_objectSpread({}, require('./yue-HK.json')), zhTWLocale)
};
var i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'zh',
  //从localStorage中拿到用户的语言选择，如果没有，那默认中文。
  messages: messages,
  silentTranslationWarn: true
});
locale.i18n(function (key, value) {
  return i18n.t(key, value);
}); //为了实现element插件的多语言切换

export default i18n;